var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.manufacturerSalesNet !== null)?_c('div',{staticClass:"retr-current__condition-group"},[_c('retr-current-condition-item',{attrs:{"condition":{
                condition_name: 'Wartość obrotu',
                retro: _vm.manufacturerSalesNet
            },"show-value-percentage":false}})],1):_vm._e(),_vm._l((_vm.sortedConditionGroups),function(conditionGroup,conditionGroupIndex){return _c('retr-current-condition-group',{key:`conditionGroup-${conditionGroupIndex}`,attrs:{"condition-group":conditionGroup,"manufacturer-name":_vm.manufacturer.manufacturer_name ?? ''}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }